import http from 'utils/http';
import {
  getAssociatedRecordsUrl,
  getBusinessInteractionLogUrl,
  getInteractionLogUrl,
  getInteractionsLogsUrl
} from './apiUrls';
import { AssociatedRecordResponse, InteractionLogResponse } from './types';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';

export function getInteractionsLogs(
  workspaceId: string,
  agentId: string,
  params?: Record<string, any>
): Promise<{ data: InteractionLogResponse[]; meta: MetaApiResponse }> {
  return http.get(getInteractionsLogsUrl(workspaceId, agentId), params);
}

export function getInteractionLog(
  workspaceId: string,
  agentId: string,
  id: string,
  params?: Record<string, any>
): Promise<InteractionLogResponse> {
  return http.get(getInteractionLogUrl(workspaceId, agentId, Number(id)), params);
}

export function getBusinessInteractionLog(id: string, params?: Record<string, any>): Promise<InteractionLogResponse> {
  return http.get(getBusinessInteractionLogUrl(Number(id)), params);
}

export function archiveInteractionLog(
  workspaceId: string,
  agentId: string,
  id: number
): Promise<{ meta: { message: string } }> {
  return http.archive(getInteractionLogUrl(workspaceId, agentId, id));
}

export function updateInteractionLog(
  workspaceId: string,
  agentId: string,
  id: number,
  payload: { interaction: { report_call: { description: string } } }
): Promise<InteractionLogResponse> {
  return http.patch(getInteractionLogUrl(workspaceId, agentId, id), payload);
}

export function getAssociatedRecords(
  contactId: number,
  params?: Record<string, any>
): Promise<{ integration_entity_contacts: AssociatedRecordResponse[]; meta: MetaApiResponse }> {
  return http.get(getAssociatedRecordsUrl(contactId), params);
}
